<template>
  <div class="animated fadeIn">
    <div class="text-center" v-if="loading">
      <span>Loading</span><br />
      <CSpinner grow="true" color="danger"></CSpinner>
    </div>
    <div class="cardheading">
      <h4><i class="fa fa-trophy"></i><span class="ml-1">Leaderboard</span></h4>
      <div class="">
        <h1 class="my-auto tableName"></h1>
      </div>
      <CRow class="mt-3">
        <CCol sm="6">
          <CSelect
            :options="['Gameplay', 'Refers',
            // 'WeeklyTask'
            ]"
            size="lg"
            :value.sync="type"
            @change="getLeaderBoard"
          />
        </CCol>
        <CCol sm="6">
          <VueCtkDateTimePicker
            label="Select Date"
            color="#FF2E75"
            v-model="date"
            only-date="true"
            @input="getLeaderBoard"
          />
        </CCol>
      </CRow>
    </div>
    <div class="card">
      <v-client-table :data="users" :columns="columns" :options="options">
        <template slot="action" slot-scope="props">
          <div>
            <router-link :to="`/users/show/${props.row.id}`">
              <span
                class="btn btn-primary btn-sm m-1"
                data-toggle="tooltip"
                data-placement="top"
                title="View"
              >
                <CIcon name="cil-magnifying-glass" size="sm" />
              </span>
            </router-link>

            <button
              @click="amountInput(props.row.id)"
              class="btn btn-danger btn-sm m-1"
              data-toggle="tooltip"
              title="Recharge"
              :href="props.row.id"
              :disabled=false

            >

              <i class="fa fa-google-wallet"></i>
            </button>
            <!-- <span @click="handleDelete(props.row.id)"
                  class="btn btn-danger btn-sm m-1"
                  data-toggle="tooltip"
                  title="Delete"
                  :href="props.row.id"
            >
                <CIcon name="cil-basket" size="sm" />
              </span> -->
          </div>
        </template>
      </v-client-table>
      <CModal title="Recharge Winner" :show.sync="amountModal">
        <CRow>
          <CCol sm="12">
            <CInput
              label="Recharge Amount"
              placeholder="Enter Recharge Amount"
              v-model="amount"
            />
          </CCol>
          <CCol sm="12">
            <CButton @click="recharge" color="primary">
              <CIcon name="cil-check-circle" />Recharge Winner
            </CButton>
          </CCol>
        </CRow>
      </CModal>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import paginate from "vuejs-paginate";
const ADMIN_URL = process.env.VUE_APP_ADMIN_URL;

export default {
  name: "LeaderBoard",
  data() {
    return {
      loading: false,
      amountModal: false,
      rechargee: "",
      amount: "",
      users: [],
      columns: ["id", "name", "phone", "score", "last_recharge", "action"],
      date: new Date(),
      type: "Gameplay",
      options: {
     //   pagination: { nav: "fixed" },
     perPage: 50,
        filterByColumn: true,
        dateColumns: ["last_recharge"],
        toMomentFormat: true,
        sortIcon: {
          base: "fa fa-sort",
          up: "fa fa-sort-up",
          down: "fa fa-sort-down",
          is: "fa fa-sort",
        },
      },
    };
  },
  created() {
    this.getLeaderBoard();
  },
  methods: {
    amountInput(id) {
      this.rechargee = id;
      this.amountModal = true;
    },
    recharge() {
      this.$swal({
        title: "Are you sure?",
        type: "warning",
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: false,
      })
        .then((result) => {
          if (result.value) {
            this.confirmRecharge();
          }
        })
        .catch((error) => {
          //console.log('Sweetalert ERROR');
        });
    },
    confirmRecharge() {
      this.loading = true;
      this.amountModal = false;
      const user_id = this.rechargee;
      axios
        .post(`${ADMIN_URL}/recharge`, {
          user_id: user_id,
          amount: this.amount,
          type:this.type
        })
        .then((response) => {
          this.loading = false;

          if (response.data.success == true) {
            this.$swal("Success", response.data.message, "success");
            this.getLeaderBoard()
          } else {
            this.$swal("Error", response.data.message, "error");
          }
        })
        .catch((error) => {
          this.loading = false;
          this.$swal("Error", error.response.data.message, "error");
        });
    },
    getLeaderBoard() {
     // this.users = [];
      axios
        .post(`${ADMIN_URL}/leaderboard`, {
          type: this.type,
          date: this.date,
        })
        .then((response) => {
          this.users = response.data;
          if (response.data.length == 0) {
            this.$swal("Sorry", "No Data Found", "warning");
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
</style>
